<form [formGroup]="clientProfile" (ngSubmit)="onSubmit()">
  <div class="row">
    <h6 class="col-12 col-md-4 details-title mt-3">
      Your profile
    </h6>
  </div>
  <div class="row">
    <div class="col-md-8 offset-md-2 col-lg-4 offset-lg-4">
      <mat-form-field>
        <input matInput formControlName="accountNumber" readonly placeholder="Account Number">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 panel-group" role="tablist" aria-multiselectable="true">
      <div role="tab">
        <a data-toggle="collapse" data-target="#my-profile" aria-controls="my-profile" (click)="collapseMyProfile = !collapseMyProfile"
          [attr.aria-expanded]="!collapseMyProfile">
          <p class="col-12 col-md-4 details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseMyProfile, 'fa-angle-down': !collapseMyProfile }">
            </i> My Contact details
          </p>
        </a>
      </div>

      <div id="my-profile" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show': !collapseMyProfile}">
        <div class="col-md-8 offset-md-2 col-lg-4 offset-lg-4">
          <div class="form-group">
            <mat-form-field>
              <mat-select formControlName="title" npDetectFocus #ipTitle="detectFocus" placeholder="Title" disabled>
                <mat-option *ngFor="let title of titles" [value]="title.id">
                  {{title.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="firstName" type="text" placeholder="First name" readonly>
            </mat-form-field>
          </div>

          <div class="form-group form-address ">
            <mat-form-field>
              <input matInput formControlName="middleName" type="text" placeholder="Middle name(s) (Optional)" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="lastName" type="text" placeholder="Last name" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput [matDatepicker]="birthdayPicker" formControlName="birthday" readonly placeholder="Date of birth">
              <mat-datepicker-toggle matSuffix [for]="birthdayPicker" disabled></mat-datepicker-toggle>
              <mat-datepicker panelClass="greengo" #birthdayPicker disabled></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="email" readonly placeholder="Email">
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="phone" placeholder="Phone number" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="postCode" type="text" placeholder="Post code" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="address1" type="text" placeholder="Address line 1" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="address2" type="text" placeholder="Address line 2 (Optional)" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="address3" type="text" placeholder="Address line 3 (Optional)" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <input matInput formControlName="countyState" type="text" placeholder="City" readonly>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <mat-select formControlName="country" placeholder="Country" disabled>
                <mat-option *ngFor="let country of countries" [value]="country.id">
                  {{country.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
      </div>
    </div>

    <div class="col-12 panel-group" role="tablist" aria-multiselectable="true">
      <div role="tab">
        <a data-toggle="collapse" data-target="#account-info" aria-controls="account-info" (click)="collapseAccountInfo = !collapseAccountInfo"
          [attr.aria-expanded]="!collapseAccountInfo">
          <p class="col-12 col-md-4 details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up':collapseAccountInfo, 'fa-angle-down': !collapseAccountInfo }">
            </i> Account information
          </p>
        </a>
      </div>
      <div id="account-info" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show': !collapseAccountInfo}">
        <p class="note-text">Below is your account manager contact information. He will help you with any queries relating to your account and
          the {{brandName}} service.
          <br> Feel free to email or call him if you need a hand walking through your {{brandName}} service.</p>
        <div class="row justify-content-center">
          <div class="col-md-4 col-12">
            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="name" type="text" readonly placeholder="Relationship manager name">
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input matInput formControlName="emailAccount" type="email" readonly placeholder="Email">
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <input class="phone-number" matInput type="tel" formControlName="phoneAccount" readonly placeholder="Contact Number">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 panel-group" role="tablist" aria-multiselectable="true">
      <div role="tab">
        <a data-toggle="collapse" data-target="#subcription-ref" aria-controls="subcription-ref" (click)="collapseSubRef = !collapseSubRef"
          [attr.aria-expanded]="!collapseSubRef">
          <p class="col-12 col-md-4 details-title">
            <i class="fa rotate-icon" [ngClass]="{ 'fa-angle-up': collapseSubRef, 'fa-angle-down': !collapseSubRef }">
            </i> Subscription preferences
          </p>
        </a>
      </div>
      <div id="subcription-ref" class="panel-collapse collapse" role="tabpanel" [ngClass]="{ 'show': !collapseSubRef}">
        <div class="ml-4">
          <mat-checkbox class="greengo break-line" disableRipple [checked]="acceptMarketingEmails" (change)="acceptMarketingEmails = !acceptMarketingEmails">Yes, I would like to be sent marketing communications and updates</mat-checkbox>
          <div class="form-group">
            <mat-checkbox class="greengo" disableRipple [checked]="acceptPolicy" (change)="acceptPolicy = !acceptPolicy">Accept {{brandName}} 
              <a *ngIf="!isPrivalgoMarkets"arget="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy" class="privacy-policy">Privacy & Cookies</a>
              Policy
            </mat-checkbox>
            <div class="error-message" *ngIf="!acceptPolicy && submitForm">
              Please accept the Privacy & Cookie Policy to Proceed
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
      <div class="form-group ">
        <div class="col-12 col-md-4 mx-auto">
          <button class="btn btn-block btn-lg" type="submit" [ngClass]="{
            'btn-greengo': clientProfile.valid && acceptPolicy,
            'btn-inactive': !clientProfile.valid || !acceptPolicy
          }" npFocusOutClicked>Save</button>
        </div>
      </div>
    </div>
  </div>
</form>
